import { SVGProps } from 'react'

export const AttachmentSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M409.6 0v68.267h-34.133c-20.48 0-34.134 13.653-34.134 34.133s13.654 34.133 34.134 34.133H409.6V204.8h-34.133c-20.48 0-34.134 13.653-34.134 34.133s13.654 34.134 34.134 34.134H409.6v68.266h-34.133c-20.48 0-34.134 13.654-34.134 34.134s13.654 34.133 34.134 34.133H409.6v68.267h-34.133c-20.48 0-34.134 13.653-34.134 34.133s13.654 34.133 34.134 34.133h68.266c20.48 0 34.134-13.653 34.134-34.133v-34.133H512c20.48 0 34.133-13.654 34.133-34.134S532.48 409.6 512 409.6h-34.133v-68.267H512c20.48 0 34.133-13.653 34.133-34.133S532.48 273.067 512 273.067h-34.133V204.8H512c20.48 0 34.133-13.653 34.133-34.133S532.48 136.533 512 136.533h-34.133V0h204.8l273.066 273.067v614.4c0 75.093-61.44 136.533-136.533 136.533H204.8c-75.093 0-136.533-61.44-136.533-136.533V136.533C68.267 61.44 129.707 0 204.8 0h204.8z m0 682.667h68.267v68.266H409.6v-68.266zM375.467 614.4c-20.48 0-34.134 13.653-34.134 34.133v136.534c0 20.48 13.654 34.133 34.134 34.133H512c20.48 0 34.133-13.653 34.133-34.133V648.533c0-20.48-13.653-34.133-34.133-34.133H375.467z'
        fill='#CF402F'
      />
      <path
        d='M682.667 0l273.066 273.067h-204.8c-40.96 0-68.266-27.307-68.266-68.267V0z'
        fill='#CF402F'
        opacity='.597'
      />
    </svg>
  )
}
